import * as React from "react";
import { gql, useQuery } from "@apollo/client";
import {
  ViewCategoryQueryQuery,
  ViewCategoryQueryQueryVariables,
} from "../../../schemaTypes";

export const viewCategoryQuery = gql`
  query ViewCategoryQuery($id: String!) {
    viewCategory(id: $id) {
      id
      name
      imgSrc
      createdBy {
        id
        role
        admin {
          id
          firstname
          lastname
          level
        }
      }
      createdAt
      updatedAt
      isArchive
    }
  }
`;

export interface WithViewCategory {
  category: ViewCategoryQueryQuery["viewCategory"] | null;
  loading: boolean;
}

interface Props {
  categoryId: string;
  children: (data: WithViewCategory) => React.ReactElement | null;
}

export const ViewCategory: React.FC<Props> = ({ categoryId, children }) => {
  const { data, loading } = useQuery<
    ViewCategoryQueryQuery,
    ViewCategoryQueryQueryVariables
  >(viewCategoryQuery, {
    variables: { id: categoryId },
  });

  let category: ViewCategoryQueryQuery["viewCategory"] | null = null;
  if (data && data.viewCategory) {
    category = data.viewCategory;
  }

  return children({
    category,
    loading,
  });
};
